<template>
    <div class="cart">
        <div class="content border">
            <div class="products">
                <div class="products-head">
                    <div class="product-left">
                        <div class="product-label">Товар</div>
                        <div class="product-label">Кол-во</div>
                    </div>
                    <div class="product-right">
                        <div class="product-label">Цена</div>
                        <div class="product-label">Сумма</div>
                    </div>
                </div>
                <div class="product" v-for="item in basketItems" :key="item.id" >
                    <div class="product-left">
                        <div class="product-img" v-if="item.additional_params">
                            <a :href="'/catalog/item/'  + item.id" class="basket_item_name">
                               <img :src="item.list_image" alt="" />
                            </a>
                        </div>
                        <div class="product-name">
                            <a :href="'/catalog/item/'  + item.id + (item.human_url ? '/' + item.human_url : '')" class="basket_item_name">
                                {{ item.name }}
                            </a>
                            <br />
                            <div class="product-params">
                                Объем: {{ item.volume }} м<sup>3</sup><br />
                                Вес: {{ item.weight }} кг<br />
                                Размеры: {{ item.length }} x {{ item.width }} x {{ item.height }} мм
                            </div>
                        </div>
                        <div class="product-count">
                            <a href="javascript:void(0)" class="count-minus" @click="decrement(item.id)"></a>
                            <div class="count-value"> {{ item.count }} </div>
                            <a href="javascript:void(0)" class="count-plus"  @click="increment(item.id)"></a>
                        </div>
                    </div>
                    <div class="product-right">
                        <div class="product-price">
                            <div class="price-value">{{ item.price_after_discount || item.current_price.amount  | priceFormat }} ₽</div>
                            <div class="price-old" v-if="item.hasDiscount">{{ item.base_price.amount  | priceFormat }} ₽</div>
                        </div>
                        <div class="product-summ">
                            <div class="summ-value"><span>{{ (item.price_after_discount || item.current_price.amount) * item.count  | priceFormat }}</span> ₽</div>
                            <button class="summ-clear hoverLineMoved def-gray" @click="remove(item.id)">Удалить</button>
                        </div>
                    </div>
                </div>
               <div class="product deleted" v-for="item in shadowBasket" :key="item.id" >
                    <div class="product-left">
                        <div class="product-img" v-if="item.additional_params">
                            <a :href="'/catalog/item/'  + item.id" class="basket_item_name">
                               <img :src="item.list_image" alt="" />
                            </a>
                        </div>
                        <div class="product-name">
                            <a :href="'/catalog/item/'  + item.id + (item.human_url ? '/' + item.human_url : '')" class="basket_item_name">
                                {{ item.name }}
                            </a>
                            <br />
                            <div class="product-params">
                                Объем: {{ item.volume }} м<sup>3</sup><br />
                                Вес: {{ item.weight }} кг<br />
                                Размеры: {{ item.length }} x {{ item.width }} x {{ item.height }} мм
                            </div>
                        </div>
                        <div class="product-count">
                            <div class="count-value"> {{ item.count }} </div>
                        </div>
                    </div>
                    <div class="product-right">
                        <div class="product-price">
                            <div class="price-value">{{ item.price_after_discount || item.current_price.amount  | priceFormat }} ₽</div>
                            <div class="price-old" v-if="item.hasDiscount">{{ item.base_price.amount  | priceFormat }} ₽</div>
                        </div>
                        <div class="product-summ">
                            <div class="summ-value"><span>{{ (item.price_after_discount || item.current_price.amount) * item.count  | priceFormat }}</span> ₽</div>
                            <button class="summ-clear hoverLineMoved def-gray" @click="addToBasket(item.id)">Восстановить</button>
                        </div>
                    </div>
                </div>

                <div class="products-result" v-if="!promocodeApply">
                  <div class="product-left bootstrap promocode-block" >
                    <input type="text"  v-model="promocode" class="form-control"  placeholder="введите промокод..."/>
                    <button class="btn" @click="applyPromocode()">Применить</button>
                  </div>
                </div>
                <div class="products-result" v-else>
                  <div class="product-left bootstrap promocode-block" style="display: block;">
                     Вы использовали промокод:  <b>{{promocode}}</b> |  <a href="javascript: void(0)" @click="removePromocode()">удалить</a>
                  </div>
                </div>

                <div class="products-result">
                    <div class="product-left" style="padding-top: 0px;">
                        <a href="/customer/checkout" class="products-formalise btn-orange">
                            Перейти к оформлению заказа
                        </a>
                    </div>
                    <div class="product-right" style="padding-top: 0px;">
                        <div class="products-allSumm">
                            <div class="allSumm-title">
                                Итого
                            </div>
                            <div class="allSumm-value">
                                <span>{{ total  | priceFormat }}</span> ₽
                            </div>
                            <div class="product-params-total">
                                Объем: {{ totalVolume }} м<sup><small>3</small></sup><br />
                                Вес: {{ totalWeight }} кг<br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Basket",
        props: ['autoPromocode'],
        data () {
          return {
            promocodeApply: false,
            promocode: null,
            shadowBasket: []
          }
        },
        computed: {
            basketItems () {
                return this.$store.state.basket;
            },
            total () {
                return this.$store.getters.basketTotal
            },
            totalWeight () {
                return this.$store.getters.basketTotalWeight.toFixed(2)
            },
            totalVolume () {
                return this.$store.getters.basketTotalVolume.toFixed(6)
            },
        },
        mounted() {
          if(this.autoPromocode){
            this.promocode = this.autoPromocode
            this.promocodeApply = true
            this.applyPromocode()
          }else if(this.$store.state.promocode){
            this.promocode = this.$store.state.promocode
            this.promocodeApply = true
            this.applyPromocode()
          }

        },
        methods: {
            increment (id) {
                this.$store.commit('incrementBasket', id)
            },
            decrement (id) {
                this.$store.commit('decrementBasket', id)
            },
            addToBasket(id) {
               this.$store.commit('addToBasket', this.shadowBasket.find(item => item.id === id));
               this.shadowBasket = this.shadowBasket.filter(item => item.id !== id)
            },
            remove (id) {
                this.shadowBasket.push(this.$store.state.basket.find(item => item.id === id))
                this.$store.commit('removeFromBasket', id)
            },
            removePromocode () {
              this.$store.commit('removePromocode')
              this.promocode = null
              this.promocodeApply = false
            },
            applyPromocode () {
              if(!this.promocode) {
                return
              }
              this.$store.commit('savePromocode', this.promocode);
              let params = {
                positions: this.$store.state.basket.map( (item) => {
                  return {
                    id : item.id,
                    count: item.count
                  }
                }),
                promocode: this.promocode
              }
              this.startApplyPromocode = true;
              this.$http.post('/customer/apply-promocode', params).then(response => {
                  this.startApplyPromocode = false;
                  response.data.map(item => {
                      this.$store.commit('setPromocodePrice', item);
                  })
                  this.promocodeApply = true
              }, () => {
                  this.removePromocode();
              })
            }

        }
    }
</script>

<style scoped>
    .product-params {
        font-weight: normal;
        color: gray;
        font-size: 80%;
    }
    .product-params-total {
        color: gray;
        text-align: right;
    }
    .promocode-block {
      padding-bottom: 10px!important;
    }
    .promocode-block .btn {
        padding: 1rem;
        background: #f9f9f9;
        border: 1px solid lightgray;
    }

    .promocode-block input {
      margin-bottom:0;
    }

    .deleted {
      background: #f8f8f8;
    }

    .deleted .product-name {
      text-decoration: line-through;
      color: grey!important;
    }

</style>